import Config from '../../../config';

const MAX_CACHE_AGE_SECS = Config.FETCH_CACHE_MAX_AGE_SECS;

const isFetchCacheExpired = (cachedData, maxCacheAge = MAX_CACHE_AGE_SECS) => {
  // If the timestamp on the cache is too old, don't use it

  if (!cachedData || !cachedData.timestamp) {
    return true;
  }
  const now = new Date();

  const diff = (now.getTime() - cachedData.timestamp) / 1000;

  const isExpired = diff >= maxCacheAge;

  return isExpired;
};

export default isFetchCacheExpired;
